import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

import * as Model from "../model";
import { UpdateColor } from "./update-color";

import type * as Repository from "../../_repository";

type Props = {
	hotelID: string;
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};

export const ColorSettingForOptionPms = ({ hotelID, optionPmsColorListQueryData }: Props) => {
	/**
	 * 初期化
	 */
	const {
		// readonly
		viewData,
		// mutable
		// カラーの更新
		onUpdateOptionPmsColorItem,
	} = Model.UseCase.useInitialized({ hotelID, optionPmsColorListQueryData });

	return (
		<div>
			<Accordion type="single" collapsible>
				<AccordionItem value="option-list">
					<AccordionTrigger>
						<p className="text-sm">色の設定</p>
					</AccordionTrigger>

					<AccordionContent>
						<div className="grid grid-cols-2 gap-x-8 gap-y-12 p-3">
							{viewData.optionPmsColorList.map(({ id, nameText, color }, index) => (
								<UpdateColor
									key={index}
									optionId={id}
									text={nameText}
									color={color}
									onUpdate={onUpdateOptionPmsColorItem}
								/>
							))}
						</div>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</div>
	);
};
